const transferPaymentMethod = {
  PIX: 'PIX',
  TRANSFER: 'TRANSFERENCIA'
};

module.exports = transferPaymentMethod;
